import { Asset } from '@/api/generatedApi';
import { HeaderText } from '@/components/HeaderText';
import { Box } from '@mui/material';
import { DependencyTreeContainer } from './DependencyTreeContainer';
import { DependencyContext } from './DependencyTreeView';
export interface DependencyTreeDetailsProperties {
  asset?: Asset;
  onTreeItemClick?: (itemId: string, context?: DependencyContext) => void;
  highlightedAssetIds?: string[];
  highlightedNodeNames?: string[];
}

export const DependencyTreeDetails = ({
  asset,
  onTreeItemClick,
  highlightedAssetIds,
  highlightedNodeNames,
}: DependencyTreeDetailsProperties) => {
  return asset?.hasDependencies ? (
    <Box color='text.primary'>
      <HeaderText margin={'4px 8px'}>Dependency Tree</HeaderText>

      <DependencyTreeContainer
        asset={asset}
        onTreeItemClick={onTreeItemClick}
        highlightedAssetIds={highlightedAssetIds}
        highlightedNodeNames={highlightedNodeNames}
      />
    </Box>
  ) : undefined;
};
